exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".layout-default .header__item[data-v-457d2244],.layout-default .popup .inner[data-v-457d2244]{margin-left:auto;margin-right:auto;padding:0 20px;max-width:1130px}@media only screen and (min-width:980px){.layout-default .header__item[data-v-457d2244],.layout-default .popup .inner[data-v-457d2244]{padding:0 40px}}.layout-default .header__item_higher[data-v-457d2244]{height:84px}.layout-default .popup[data-v-457d2244]{width:100%;z-index:4;display:block;box-shadow:0 3px 5px rgba(0,0,0,.25);background-color:#ededed;max-height:100%;overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-457d2244","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/layout/Default.vue
// module id = 2f9c6abf087c0d03fb67
// module chunks = 0